import i18n from './i18n';

export const __ = (key: string, params: object = {}) =>
    i18n.t(key, { ...params });
